/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Go_Offline_TitleInputs */



/**
* | output |
* | --- |
* | "Go Offline?" |
*
* @param {Offline_Go_Offline_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const offline_go_offline_title = /** @type {((inputs?: Offline_Go_Offline_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Go_Offline_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Passer hors ligne ?")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Modo sin conexión?")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Ficar offline?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Andare offline?")
	return /** @type {LocalizedString} */ ("Go Offline?")
});